import { Alert, Button, IconButton, Snackbar } from "@mui/material";
import { XIcon } from "@phosphor-icons/react";
import { t } from "i18next";
import { useState } from "react";

import { useNewVersionAvailable } from "./version.store";

export function NewVersionBanner() {
	const newVersionAvailable = useNewVersionAvailable();
	const [dismissed, setDismissed] = useState(false);

	if (!newVersionAvailable || dismissed) {
		return null;
	}

	return (
		<Snackbar open anchorOrigin={{ vertical: "top", horizontal: "center" }}>
			<Alert
				severity="info"
				// MUI Alert defaults to flex-start; center aligns the action
				// buttons with the single-line message.
				sx={{ alignItems: "center" }}
				action={
					<>
						<Button
							color="inherit"
							size="small"
							onClick={() => window.location.reload()}
						>
							{t("Refresh")}
						</Button>
						<IconButton
							color="inherit"
							size="small"
							aria-label={t("Dismiss")}
							onClick={() => setDismissed(true)}
						>
							<XIcon />
						</IconButton>
					</>
				}
			>
				{t("New version available")}
			</Alert>
		</Snackbar>
	);
}
